<template>
    <FormSection title="Edit Referral Document" :full-height="true" :application-id="options.application" class="p-2">
        <template #content>
            <div class="form-group col-10 ps-2 pt-2">
                <label for="assigned-to"> Document Name: </label>
                <input
                    type="text"
                    placeholder="Enter Name"
                    class="form-control"
                    v-model="fileName"
                    @blur="v$.fileName.$touch"
                    :class="`${!v$.fileName.$error ? '' : 'field-invalid'}`"
                />
                <span v-if="v$.fileName.$error" class="field-invalid">Document Name is required.</span>
            </div>

            <div class="form-group col-10 pt-2 ps-2 hh-document-type">
                <label for="assigned-to"> Document Type: </label>
                <TypeaheadInput
                    placeholder="Start Typing..."
                    :data="searchedTypes"
                    :value="selectedUploadType"
                    v-on:valueChanged="uploadTypeChanged"
                    :showAllByDefault="true"
                    :openOnFocus="true"
                ></TypeaheadInput>
            </div>

            <div class="footer">
                <button type="button" class="btn btn-light border border-secondary me-2" @click="cancel()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary border border-primary" @click="ok()">Save</button>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./EditHHDocument.ts"></script>

<style>
.hh-document-type .dropdown-menu.show {
    position: fixed;
    left: 1.8rem;
    top: 12rem;
}
</style>
